export const DEFAULT_POST_LOGIN_PATH = '/home'

export const resolvePostLoginPath = (pathname: string): string | null => {
  if (pathname === '/login' || pathname === '/') return DEFAULT_POST_LOGIN_PATH

  return null
}
